<template>
  <div class="modal-overlay">
    <div class="modal-background" />
    <form class="modal" @submit.prevent="submitForm">
      <div class="modal-title">Complete the registration</div>
      <div class="modal-subtitle">To complete the registration, please fill out the form</div>
      <spinner v-if="loading" style="align-self: center;"/>
      <div v-else style="width: 100%;">
        <text-field
          v-model.trim="form.firstName"
          label="Name"
          :validator="$v.form.firstName"
        />
        <text-field
          v-model.trim="form.lastName"
          label="Surname"
          :validator="$v.form.lastName"
        />
      </div>
      <main-button 
        text="Finish"
        class="finish-btn" 
        :disabled="loading"
      />
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '../../utils'
export default {
  name: 'complete-registration-modal',
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.user || {},
      loading: false
    }
  },
  validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
      },
    }
  },
  methods: {
    async submitForm() {
      submitGuard(this, async () => {
        this.loading = true
        const { firstName, lastName } = this.form
        this.$emit('submit', { firstName, lastName })
      })
    },
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  max-width: 385px;
  border-radius: 12px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;
  display: inline-flex;
  flex-direction: column;
  padding: 24px 20px;
  align-items: flex-end;
  gap: 24px;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.modal-subtitle {
  align-self: stretch;
  color:  #979797;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.finish-btn {
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  align-self: start;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>